import { FileUploadData, FileUploadResponse } from "@/types/file";
import { apiUrl } from "../../utils/url";
import { HttpClient } from "../HttpClient";
import { IFilesService } from "./IFilesService";

export class FilesService implements IFilesService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
      timeout: 30000,
      headers: {},
    });
  }

  async uploadFile(fileData: FileUploadData, typeId: number): Promise<number> {
    try {
      const formData = new FormData();
      formData.append("file", fileData.file);
      const id = await this.httpClient.post<number>(
        `/files/upload?typeId=${typeId}`,
        formData,
        {
          headers: {
            Accept: "application/json",
          },
        },
        true,
      );

      return id;
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível carregar o ficheiro. Confirme o formato, o tamanho e o nome do ficheiro.",
      );
    }
  }

  async downloadContactFile(): Promise<Blob> {
    try {
      return await this.httpClient.get<Blob>(`/files/download/contactFile`, {
        headers: {
          Accept: "application/octet-stream",
        },
      });
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível descarregar o modelo de contactos. Tente novamente mais tarde.",
      );
    }
  }

  async uploadContactFile(
    fileData: FileUploadData,
  ): Promise<FileUploadResponse> {
    try {
      const formData = new FormData();
      formData.append("file", fileData.file);

      return await this.httpClient.post<FileUploadResponse>(
        `/files/upload/contactFile`,
        formData,
        {
          headers: {
            Accept: "application/json",
          },
        },
      );
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível importar o ficheiro de contactos. Use o modelo descarregado em formato .xlsx.",
      );
    }
  }

  async downloadSaleCheckoutFile(saleId: number): Promise<Blob> {
    try {
      const response = await this.httpClient.get<Blob>(
        `/files/sale/${saleId}/pdf`,
        {
          headers: {
            Accept: "*/*",
          },
        },
      );

      return response;
    } catch (error) {
      throw new Error(
        error instanceof Error
          ? error.message
          : "Não foi possível descarregar o resumo da venda. Confirme se a venda está carregada e tente novamente.",
      );
    }
  }
}
